import { BulletList as BulletListExtension } from '@tiptap/extension-bullet-list';
import { CustomBulletListExtensionName, CustomListItemExtensionName } from './utils/names';

export const CustomBulletList = BulletListExtension.extend({
  name: CustomBulletListExtensionName,

  addOptions() {
    return {
      itemTypeName: CustomListItemExtensionName,
      HTMLAttributes: {},
      keepMarks: true,
      keepAttributes: true,
    };
  },
});
